import { api, apis, getIn18Text } from 'api';
const codeMap = {
    QQMail: 'https://service.mail.qq.com/detail/0/75',
    '163Mail': 'https://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac2a5feb28b66796d3b',
    '126Mail': 'https://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac2a5feb28b66796d3b',
    TencentQiye: 'https://open.work.weixin.qq.com/help2/pc/19886?person_id=1',
    Gmail: 'https://support.google.com/accounts/answer/185833?visit_id=637011925839380259-3739600675&rd=1#ts=3141880',
};
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.getSystemApi();
export const getAuthCodeMap = async () => {
    const newAuthMap = Object.assign({}, codeMap);
    try {
        const res = await mailApi.getAuthCodeDesc();
        if (res === null || res === void 0 ? void 0 : res.length) {
            res.forEach(desc => {
                switch (desc.desc) {
                    case '163':
                        newAuthMap['163Mail'] = desc.url;
                        break;
                    case '126':
                        newAuthMap['126Mail'] = desc.url;
                        break;
                    case 'qq':
                        newAuthMap['QQMail'] = desc.url;
                        break;
                    case 'qq_qiye':
                        newAuthMap['TencentQiye'] = desc.url;
                        break;
                    case 'gmail':
                        newAuthMap['Gmail'] = desc.url;
                        break;
                }
            });
        }
    }
    catch (error) {
        console.error(error);
    }
    return newAuthMap;
};
export const getBindEmailMessage = async (email) => {
    if (!email) {
        return '';
    }
    const currentUser = systemApi.getCurrentUser();
    if (currentUser && (email === currentUser.id || (currentUser.loginAccount && currentUser.loginAccount === email))) {
        return getIn18Text('BIND_SELF_NOALLOW');
    }
    const emailItem = await getBindAccountInfo(email);
    if (emailItem) {
        if (emailItem.expired) {
            return getIn18Text('BIND_SUBACCOUNT_EXPIRED');
        }
        return getIn18Text('BIND_SUBACCOUNT_ALREADY');
    }
    return '';
};
export const getBindAccountInfo = async (email) => {
    if (!email) {
        return null;
    }
    try {
        const allSubAccounts = await accountApi.getAllSubAccounts();
        const emailItem = allSubAccounts.find(item => { var _a; return ((_a = item.agentEmail) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === (email === null || email === void 0 ? void 0 : email.toLocaleLowerCase()); });
        return emailItem || null;
    }
    catch (error) {
        console.error('getBindAccountInfo error', error);
        return null;
    }
};
export const getAccountType = (type) => {
    if (type === 'GmailPerson') {
        return 'Gmail';
    }
    if (type === 'OutlookQiyeGlobal' || type === 'OutlookQiyeChina' || type === 'OutlookPerson') {
        return 'Outlook';
    }
    return type;
};
